<template>
  <v-container class="pa-6" style="max-width: 1680px">
    <v-row align="center">
      <v-col cols="auto" class="pr-0">
        <div class="text-h5">
          <span style="font-family: Inter; text-transform: uppercase">
            Alerts
          </span>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        sm="auto"
        class="d-flex flex-column flex-sm-row align-start align-sm-center px-0"
      >
        <v-chip
          v-if="errorNotifications > 0 && show.errors"
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0"
          style="
            height: 36px;
            background-color: hsl(0, 87%, 94%) !important;
            color: hsl(0, 87%, 59%) !important;
            border-color: hsl(0, 87%, 59%) !important;
          "
          @click="show.errors = !show.errors"
        >
          <v-icon color="hsl(0, 87%, 59%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(0, 87%, 59%)"
            >{{ errorNotifications }}
            <span v-if="errorNotifications == 1">Error</span
            ><span v-else>Errors</span>
          </span>
        </v-chip>
        <v-chip
          v-else
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0"
          style="
            height: 36px;
            background-color: hsl(0, 0%, 94%) !important;
            color: hsl(0, 0%, 59%) !important;
            border-color: hsl(0, 0%, 59%) !important;
          "
          @click="show.errors = !show.errors"
        >
          <v-icon color="hsl(0, 0%, 59%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(0, 0%, 59%)"
            >{{ errorNotifications }}
            <span v-if="errorNotifications == 1">Error</span
            ><span v-else>Errors</span>
          </span>
        </v-chip>
        <v-chip
          v-if="warningNotifications > 0 && show.warnings"
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0 ml-0 ml-sm-3"
          style="
            height: 36px;
            background-color: hsl(40, 87%, 94%) !important;
            color: hsl(40, 87%, 49%) !important;
            border-color: hsl(40, 87%, 49%) !important;
          "
          @click="show.warnings = !show.warnings"
        >
          <v-icon color="hsl(40, 87%, 49%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(40, 87%, 49%)"
            >{{ warningNotifications }}
            <span v-if="warningNotifications == 1">Warning</span
            ><span v-else>Warnings</span>
          </span>
        </v-chip>
        <v-chip
          v-else
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0 ml-0 ml-sm-3"
          style="
            height: 36px;
            background-color: hsl(0, 0%, 94%) !important;
            color: hsl(0, 0%, 59%) !important;
            border-color: hsl(0, 0%, 59%) !important;
          "
          @click="show.warnings = !show.warnings"
        >
          <v-icon color="hsl(0, 0%, 59%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(0, 0%, 59%)"
            >{{ warningNotifications }}
            <span v-if="warningNotifications == 1">Warning</span
            ><span v-else>Warnings</span>
          </span>
        </v-chip>
        <v-chip
          v-if="informationNotifications > 0 && show.notifications"
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0 ml-0 ml-sm-3"
          style="
            height: 36px;
            background-color: hsl(220, 87%, 94%) !important;
            color: hsl(220, 87%, 49%) !important;
            border-color: hsl(220, 87%, 49%) !important;
          "
          @click="show.notifications = !show.notifications"
          ><v-icon color="hsl(220, 87%, 49%)" class="mr-1">mdi-circle</v-icon
          ><span style="font-family: Inter; color: hsl(220, 87%, 49%)"
            >{{ informationNotifications }}
            <span v-if="informationNotifications == 1">Notification</span
            ><span v-else>Notifications</span></span
          ></v-chip
        >
        <v-chip
          v-else
          light
          label
          outlined
          class="rounded-pill mb-2 mb-sm-0 ml-0 ml-sm-3"
          style="
            height: 36px;
            background-color: hsl(0, 0%, 94%) !important;
            color: hsl(0, 0%, 59%) !important;
            border-color: hsl(0, 0%, 59%) !important;
          "
          @click="show.notifications = !show.notifications"
          ><v-icon color="hsl(0, 0%, 59%)" class="mr-1">mdi-circle</v-icon
          ><span style="font-family: Inter; color: hsl(0, 0%, 59%)"
            >{{ informationNotifications }}
            <span v-if="informationNotifications == 1">Notification</span
            ><span v-else>Notifications</span></span
          ></v-chip
        >
      </v-col>
      <v-col cols="12" sm="auto" class="pl-0 d-flex justify-start">
        <v-btn
          icon
          outlined
          color="hsl(0, 0%, 59%)"
          style="background-color: hsl(0, 0%, 94%)"
          @click="silenceAll"
        >
          <v-icon small>mdi-bell-sleep</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="activeNotifications > 0" align="center">
      <v-col cols="auto" class="pr-0">
        <div class="text-h6">
          <span style="font-family: Inter"> Live </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="notification in pinnedNotifications"
        :key="notification.id"
        cols="12"
        sm="12"
        md="6"
        xl="4"
      >
        <notification-component
          :notification="notification"
          :show="show"
          @editAlert="editAlert(notification)"
        />
      </v-col>
    </v-row>
    <v-row v-if="notifications.length > 0" align="center">
      <v-col cols="auto" class="pr-0">
        <div class="text-h6">
          <span style="font-family: Inter"> Historical </span>
        </div>
      </v-col>
    </v-row>
    <v-timeline class="mt-6" style="padding-top: 0px; padding-bottom: 0px">
      <timeline-item
        v-for="notification in historicalNotifications"
        :key="notification.id"
        :notification="notification"
        display="alerts"
      />
    </v-timeline>
  </v-container>
</template>

<script>
import NotificationComponent from '../components/Notifications/NotificationComponent.vue';
import TimelineItem from '../components/Notifications/TimelineItem.vue';

import { mapGetters } from 'vuex';

export default {
  components: {
    NotificationComponent,
    TimelineItem,
  },
  data: () => ({
    show: {
      errors: true,
      warnings: true,
      notifications: true,
      archived: true,
    },
  }),
  computed: {
    ...mapGetters({
      allNotifications: 'allNotificationsByTimeCleared',
      allNotificationsByTimeRaised: 'allNotificationsByTimeRaised',
    }),
    notifications() {
      let toggles = this.show;
      return this.allNotifications.filter((notification) => {
        return (
          !(!toggles.errors && notification.type == 'error') &&
          !(!toggles.warnings && notification.type == 'warning') &&
          !(!toggles.notifications && notification.type == 'information') &&
          !(!toggles.archived && notification.archived)
        );
      });
    },
    pinnedNotifications() {
      let toggles = this.show;
      return this.allNotificationsByTimeRaised.filter((notification) => {
        return (
          !(!toggles.errors && notification.type == 'error') &&
          !(!toggles.warnings && notification.type == 'warning') &&
          !(!toggles.notifications && notification.type == 'information') &&
          (!notification.archived ||
            (notification.is_silenced && !notification.cleared))
        );
      });
    },
    historicalNotifications() {
      return this.notifications.filter((notification) => {
        return (
          notification.archived &&
          (!notification.is_silenced || notification.cleared)
        );
      });
    },
    silencedNotifications() {
      return this.notifications.filter((notification) => {
        return notification.is_silenced && !notification.cleared;
      });
    },
    activeNotifications() {
      return this.notifications.filter((notification) => {
        return !notification.archived;
      }).length;
    },
    successNotifications() {
      return this.allNotifications.filter((notification) => {
        return notification.type == 'success' && !notification.archived;
      }).length;
    },
    informationNotifications() {
      return this.allNotifications.filter((notification) => {
        return notification.type == 'information' && !notification.archived;
      }).length;
    },
    warningNotifications() {
      return this.allNotifications.filter((notification) => {
        return notification.type == 'warning' && !notification.archived;
      }).length;
    },
    errorNotifications() {
      return this.allNotifications.filter((notification) => {
        return notification.type == 'error' && !notification.archived;
      }).length;
    },
  },
  methods: {
    accentColor(notification) {
      if (notification.archived) return 'hsl(0, 0%, 59%)';
      switch (notification.type) {
        case 'success':
          return 'hsl(120, 67%, 39%)';
        case 'information':
          return 'hsl(220, 87%, 49%)';
        case 'warning':
          return 'hsl(40, 87%, 49%)';
        case 'error':
          return 'hsl(0, 87%, 59%)';
        default:
          return 'hsl(0, 0%, 59%)';
      }
    },
    icon(notification) {
      switch (notification.type) {
        case 'success':
          return 'mdi-check-circle-outline';
        case 'information':
          return 'mdi-information-slab-circle-outline';
        case 'warning':
          return 'mdi-alert-outline';
        case 'error':
          return 'mdi-alert-circle-outline';
        default:
          return 'mdi-bell-outline';
      }
    },
    notificationTypeColor(notificationType, notificationArchived) {
      if (notificationArchived) return 'grey';
      else if (notificationType == 'success') return 'green';
      else if (notificationType == 'error') return 'red';
      else if (notificationType == 'warning') return '#f4b236';
      else return 'grey';
    },
    silenceAll() {
      // Ingestor_Not_Connect not currently silencable
      var notifications = this.notifications;
      var alertSources = notifications.map((n) => n.source);
      var alertMetrics = notifications.map((n) => n.metric);
      this.$emit('editMultipleAlerts', { alertSources, alertMetrics });
    },
    editAlert(notification) {
      this.$emit('editAlert', {
        metric: notification.metric,
        source: notification.source,
        url: notification.url,
      });
    },
  },
};
</script>

<style>
.v-timeline-item:last-of-type {
  padding-bottom: 0px;
}
</style>
